module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.show,
      "title": "评价详情",
      "center": "",
      "destroy-on-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.show = $event
      },
      "close": _vm.close
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "分数"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.form.score))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "内容"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.form.comment))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价时间"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.form.created_at))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bdbedfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/activity/components/commentDetail.vue
// module id = 916
// module chunks = 0